import React from "react";
import * as ReactDOMClient from "react-dom/client";
import App from "./App";
import { MaterialUIControllerProvider } from "./context";
import { BrowserRouter } from "react-router-dom";
import { UserDetailsContextProvider } from "./context/auth";
import LoadingContext from "./context/loading";
import './index.css'
import { DesignationProvider } from "./context/designationcontext";

const container = document.getElementById("root");
const root = ReactDOMClient.createRoot(container);
// console.warn = () => {};


root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <UserDetailsContextProvider>
        <LoadingContext>
          <DesignationProvider>
          <App />
          </DesignationProvider>
        </LoadingContext>
      </UserDetailsContextProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
